/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll, getByInvestigator } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";
import { useSelector } from "react-redux";
import { IStore } from "../../../interfaces/IStore";
import { IUser } from "../../../interfaces/IUser";
import { normalizer } from "../../../utils/auxiliar/investigators";
import { Table } from "react-bootstrap";
import * as XLSX from "xlsx";

export const CoreFacilities: FC = () => {
  let { staffId, isAdmin, userRoleId } = useSelector(
    ({ user }: IStore) => user as IUser
  );
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { COREFACILITIES } = paths;
  const [coreFacilities, setCoreFacilities] = useState<ICoreFacilityShort[]>([]);
  const [displayCoreFacilities, setDisplayCoreFacilities] = useState<ICoreFacilityShort[]>([]);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: string;
  } | null>(null);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);
  interface ICoreFacilityShort {
    [key: string]: any;
    id: string;
    nombreEs: string;
    nombreEn: string; 
    descripcionEs: string;
    descripcionEn: string; 
    infoEs: string;  
    infoEn: string; 
    serviciosEs: string;
    serviciosEn: string;
    equipamientosEs: string;
    equipamientosEn:string;
    enlaces:string;
    publicaciones: string;
    tarifasEs: string;
    tarifasEn: string;
    guiasEs:string
    guiasEn: string;
    staffCoreFacilities?: {
      coreFacilityRole: string;
      staff: { nombre: string; apellidos: string };
    }[];
  }

const loadData = async () => {
  try {
    const response = await getAll(COREFACILITIES, source);

    if (isMountedRef.current) {
      let filteredCoreFacilities = response;

      // Si el usuario NO es admin, aplicar el filtro
      if (!isAdmin) {
        filteredCoreFacilities = response.filter(
          (coreFacility: any) =>
            coreFacility.staffCoreFacilities.some((staff: any) => staff?.staff?.id === staffId) 
        );
      }

      setCoreFacilities(filteredCoreFacilities);
      setDisplayCoreFacilities(filteredCoreFacilities);
    }
    setIsLoading(false);
  } catch (error) {
    console.log("HTTP call cancelled");
  }
};

  const searchBar = (value: string) => {
    const lowerCaseValue = value.toLowerCase(); // Solo convierte el valor a minúsculas

    setDisplayCoreFacilities(
      coreFacilities.filter(
        ({ nombreEs }) => nombreEs.toLowerCase().includes(lowerCaseValue) // Filtra solo por tituloEs
      )
    );

    if (!value) {
      setDisplayCoreFacilities(coreFacilities);
    }
  };

  const sortByColumn = (key: keyof ICoreFacilityShort) => {
    let direction = "desc";

    if (sortConfig?.key === key && sortConfig.direction === "desc") {
      direction = "asc";
    }

    setSortConfig({ key: key as string, direction });

    const sortedData = [...displayCoreFacilities].sort((a, b) => {
      if (key === "staffCoreFacilities") {
        // Extraer el apellido del primer IP en cada unidad de apoyo o asignar una cadena vacía si no existe
        const lastNameA =
          a.staffCoreFacilities?.find(({ coreFacilityRole }) => coreFacilityRole === "ip")
            ?.staff?.apellidos || "";
        const lastNameB =
          b.staffCoreFacilities?.find(({ coreFacilityRole }) => coreFacilityRole === "ip")
            ?.staff?.apellidos || "";

        // Unidades de apoyo sin IPs deben ir al final
        if (!lastNameA && lastNameB) return 1;
        if (!lastNameB && lastNameA) return -1;
        if (!lastNameA && !lastNameB) return 0;

        return (
          lastNameA.localeCompare(lastNameB) * (direction === "asc" ? 1 : -1)
        );
      }

      return a[key] < b[key]
        ? direction === "asc"
          ? -1
          : 1
        : a[key] > b[key]
        ? direction === "asc"
          ? 1
          : -1
        : 0;
    });

    setDisplayCoreFacilities(sortedData);
  };

  const columnHeaders: Record<string, string> = {
    nombreEs: "TÍTULO", // Cambio aquí, pero mantiene la clave "acronimo"    
    staffCoreFacilities: "Staff",
    
  };

  const handleExportToExcel = () => {
    if (!coreFacilities) return;

    const dataToExport = coreFacilities.map((coreFacility) => ({
      ID: coreFacility.id,
      "Título (ES)": coreFacility.nombreEs,
      "Título (EN)": coreFacility.nombreEn,
      "Resumen (ES)": coreFacility.descripcionEs,
      "Resumen (EN)": coreFacility.descripcionEn,
      "Info (ES)": coreFacility.infoEs,
      "Info (EN)": coreFacility.infoEn,
      "Servicios (ES)": coreFacility.serviciosEs,
      "Servicios (EN)": coreFacility.serviciosEn,
      "Equipamientos (ES)": coreFacility.equipamientosEs,
      "Equipamientos (EN)": coreFacility.equipamientosEn,
      Enlaces: coreFacility.enlaces,
      Publicaciones: coreFacility.publicaciones,
      "Tarifas (ES)": coreFacility.tarifasEs,
      "Tarifas (EN)": coreFacility.tarifasEn,
      "Guias (ES)": coreFacility.guiasEs,
      "Guias (EN)": coreFacility.guiasEn,
      Staff:
        coreFacility.staffCoreFacilities
          ?.map(
            (s) =>
              `${s.coreFacilityRole}: ${
                s.staff
                  ? `${s.staff.nombre} ${s.staff.apellidos}`
                  : "Sin asignar"
              }`
          )
          .join(" | ") || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "CoreFacilities");

    XLSX.writeFile(workbook, "unidadesdeapoyo.xlsx");
  };

  return (
    <div className="container-fluid p-4">
      {(isAdmin || userRoleId === 2 || userRoleId === 3) && (
        <>
          {" "}
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Unidades de apoyo</h3>
              </div>
              <div>
                <button
                  className="baseBtn"
                  onClick={() => history.push(ROUTES.CoreFacilities.create)}
                >
                  + Añadir
                </button>
                <button className="baseBtn ml-2" onClick={handleExportToExcel}>
                  Descargar Excel
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-4">
            <Form.Group as={Col}>
              <InputGroup className="shadow">
                <InputGroup.Prepend>
                  <InputGroup.Text className="inputGroup ">
                    <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <Form.Control
                  type="text"
                  placeholder="Buscar por título o referencia..."
                  className="form-control"
                  onChange={({ target: { value } }) => searchBar(value)}
                />
              </InputGroup>
            </Form.Group>
          </div>
          <Table striped bordered hover>
            <thead>
              <tr>
                {Object.keys(columnHeaders).map((col) => (
                  <th
                    key={col}
                    onClick={() => sortByColumn(col)}
                    style={{ cursor: "pointer" }}
                  >
                    {columnHeaders[col]}{" "}
                    {sortConfig?.key === col
                      ? sortConfig.direction === "asc"
                        ? "▲"
                        : "▼"
                      : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {displayCoreFacilities?.length > 0 ? (
                displayCoreFacilities.map(
                  ({
                    id,
                    nombreEs,         
                    staffCoreFacilities           
                  }) => {
                    // Filtramos los IPs
                    const ips =
                      staffCoreFacilities
                        ?.filter(({ coreFacilityRole }) => coreFacilityRole === "ip")
                        .map(
                          ({ staff }) => `${staff.nombre} ${staff.apellidos}`
                        )
                        .join(", ") || "-";

                    return (
                      <tr
                        key={id}
                        className="pointer"
                        onClick={() =>
                          history.push(`${ROUTES.CoreFacilities.all}/${id}`)
                        }
                      >
                        <td>{nombreEs}</td>         
                        <td>{ips}</td>          
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    No hay unidades de apoyo para mostrar
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
};
